// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"5d06017e","407":"861c8e40","453":"d9f4b9ca","586":"20ca64d7","627":"e897ed60","630":"fbb6b0e6","712":"e44a3b1a","973":"477182e8"}[chunkId] + ".chunk.js";
};